import { Table } from 'antd'
import React, { useMemo } from 'react'

export const AppTable = props => {
  const tableScrollWidth = useMemo(() => {
    return props?.columns?.reduce((acc, cur) => acc + (cur?.width ?? 180), 0)
  }, [props.columns])

  return (
    <Table
      pagination={false}
      scroll={{ x: tableScrollWidth }}
      {...props}
      className={`${props.className || ''} customTable`}
      rowClassName={(_, index) => (index % 2 !== 0 ? 'custom-bg-row' : '')}
    />
  )
}
